<template>
    <div class="TotalPower" >
        <Title firstName="总功率" lastName="TOTAL POWER"/>
        <div class="echarts">
            <div class="edata">
                <div class="title">实时总功率</div>
                <div class="num">--<span> kVA</span></div>
            </div>
            <div class="selectMonitor" @click="ishow=!ishow">
                {{currentName}}
                <i class="el-icon-arrow-down"></i>
                <div class="list" v-if="ishow">
                    <SelectList :selectList="selectList" @tabTitle="tabTitle" keyk="id" keyval="value"/>
                </div>
            </div>
            <div class="eview">
                <!-- <Graph :chartId="chartId" :seriesData="seriesData1" :xData="xData" v-if="seriesData.length >0"/> -->
                <!-- <charts id="TotalPowerchart" :series="seriesOption" :xData="xData"></charts> -->
                <div class="noneData" >
                    光伏数据暂未接入
                </div>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
const Graph = () => import('../../../../components/echarts/graph.vue')
const charts = () => import('../../../../components/echarts/charts.vue')
const SelectList = () => import('../../../../components/title/selectList')
export default {
    data(){
        return {
            seriesOption:[],
            xData:[],
            ishow:false,
            currentName:"变配电",
            selectList:[
                {
                    id:1,
                    value:'变配电'
                },
                {
                    id:2,
                    value:'光伏'
                }
            ],
        }
    },
    components:{
        Title,Graph,charts,SelectList
    },
    created(){
        this.init();
    },
    methods:{
       init(){
           let xData = []
            for(let i = 0; i <= 24; i++){
                xData.push((i<10?'0'+i:i)+':00')
            }
            this.xData = xData
            let seriesData = [0, 0, 0, 0, 0, 0, 10.11, 11.23, 23.71, 45.64, 50.22, 70.54, 95.23, 96.11, 95.32, 95.20, 84.11, 50.44, 30.21, 0, 0, 0, 0, 0]
            this.seriesOption = [{
                name: "",
                type:"line",
                data: seriesData,
            }]
       }
    },
    watch:{
        
    },
    computed:{
        routeName() {
            return this.$route.query.name;
        },
        weather(){
            return this.$store.state.Cang.weather
        }
    }
}
</script>

<style lang="less" scoped>
    .TotalPower{
        // height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 7.4vh;
        right: 1vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            .list{
                height: 10.5vh;
                width: 20vw;
                position: absolute;
                right: 0;
                top: 100%;
                z-index: 11;
                text-align: left;
            }
            .selectMonitor{
                height: 3vh;
                line-height: 3vh;
                text-align: right;
                padding-right: 0.5vw;
                color: #E6F3FD ;
                cursor: pointer;
                position: absolute;
                top: 10rem;
                right: 0;
                z-index: 99;
            }
            .edata{
                // height: 9vh;
                // display: flex;
                // justify-content: space-around;
                text-align: center;
                padding: 15rem 0;
                .title{
                    font-size: 14rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #E6F3FD;
                }
                .num{
                    padding-top: 3rem;
                    font-size: 20rem;
                    font-family: zcoolqingkehuangyouti;
                    font-weight: 400;
                    color: #00DEFF;
                    span{
                        font-size: 14rem;
                    }
                }
            }

            .eview{
                padding: 0 0.5vw;
                height: 16vh;
                position: relative;

                .icon{
                    position: absolute;
                    right: 1vw;
                    top: 0;
                    color: rgba(230,243,253, 0.7);
                    &>span{
                        width: 12rem;
                        height: 12rem;
                        display: inline-block;
                        vertical-align: -1rem;
                        margin-right: 5rem;
                    }
                    &>span:nth-of-type(1){
                        background-color: #f6bd16;
                    }
                    &>span:nth-of-type(2){
                        background-color: #1290ff;
                        margin-left: 5rem;
                    }
                }

                .noneData{
                    display: inline-block;
                    position: absolute;
                    top: 50%;
                    color: rgba(230,243,253, 0.7);
                    left: 50%;
                    transform: translate(-50% , -50%);
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
    .power1{
        top: 30.3vh;
    }

</style>